module.exports = __webpack_public_path__ + "img/1970East-025_WEB-min.6403f4b6.jpg";